import React, { FC, ReactNode } from 'react';
import Primitive from '../../../types/primitive';
import FieldCheckbox from '../../atoms/field-checkbox/field-checkbox';

interface FieldCheckboxGroupProps {
  readonly layout?: 'vertical' | 'horizontal';
  readonly error?: boolean;
  readonly options: {
    readonly value: Primitive;
    readonly label: ReactNode;
    readonly disabled?: boolean;
  }[];
  readonly value?: Primitive[];
  readonly onChange?: (value: Primitive[]) => void;
}

const FieldCheckboxGroup: FC<FieldCheckboxGroupProps> = ({
  layout,
  error,
  options,
  value,
  onChange,
}) => {
  const horizontalLayout =
    layout === 'horizontal' ? 'md:flex-row md:space-y-0 md:space-x-6' : '';

  return (
    <div className={`flex flex-col space-y-3 ml-1px ${horizontalLayout}`}>
      {options.map((option) => (
        <FieldCheckbox
          key={String(option.value)}
          theme="checkbox"
          label={option.label}
          disabled={option.disabled}
          error={error}
          value={value?.includes?.(option.value)}
          onChange={() => {
            const valueOrEmpty = value || [];

            onChange(
              valueOrEmpty.includes(option.value)
                ? valueOrEmpty.filter((element) => option.value !== element)
                : [...valueOrEmpty, option.value]
            );
          }}
        />
      ))}
    </div>
  );
};

FieldCheckboxGroup.defaultProps = {
  layout: 'vertical',
  error: false,
  value: null,
  onChange: null,
};

export default FieldCheckboxGroup;
